<template>
  <section id="hero" class="hero">
    <div class="container">
      <h1 class="title">加恒科技 · 智能创新引领未来</h1>
      <p class="subtitle">专注于智能设备软件开发、数据平台与企业级解决方案，助力客户数字化转型与业务增长。</p>
      <div class="cta">
        <a href="#pricing" class="btn primary">预约演示</a>
        <a href="#features" class="btn">了解方案</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Hero'
}
</script>

<style scoped>
.hero {
  background: radial-gradient(1200px 600px at 50% -200px, #1f2937, #0b1020);
  color: #e5e7eb;
  padding: 96px 16px 72px;
  text-align: center;
}
.container {
  max-width: 900px;
  margin: 0 auto;
}
.title {
  font-size: 40px;
  line-height: 1.2;
  margin: 0 0 12px;
}
.subtitle {
  opacity: 0.9;
  margin: 0 0 24px;
}
.cta {
  display: inline-flex;
  gap: 12px;
}
.btn {
  padding: 10px 18px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  color: inherit;
  text-decoration: none;
}
.btn.primary {
  background: #22c55e;
  border-color: #22c55e;
  color: #0b1020;
}
.btn:hover {
  opacity: 0.95;
}
@media (max-width: 640px) {
  .title {
    font-size: 28px;
  }
}
</style>


